// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"eccf85bd5690d9a8925e","339":"13adb9036a0c9ea2efbc"}[chunkId] + ".js";
};